import { useCallback } from 'react'
import 'ol/ol.css' // Estilo básico do OpenLayers
import { Tile as TileLayer } from 'ol/layer'
import { OSM, StadiaMaps, XYZ } from 'ol/source'
// import { OpenLayersBaseMap } from '../../../../types'

interface useBaseLayerProps {
  baseLayerSourceName?: any
}

function useBaseLayer({ baseLayerSourceName }: useBaseLayerProps) {
  const createLayer = useCallback((): TileLayer => {
    switch (baseLayerSourceName) {
      case 'STADIA_WATERCOLOR':
        return new TileLayer({
          source: new StadiaMaps({ layer: 'stamen_watercolor' }),
        })
      case 'STADIA_SMOOTH_DARK':
        return new TileLayer({
          source: new StadiaMaps({
            layer: 'alidade_smooth_dark',
            retina: true,
          }),
        })
      case 'STADIA_TERRAIN':
        return new TileLayer({
          source: new StadiaMaps({
            layer: 'stamen_terrain',
            retina: true,
          }),
        })
      case 'STADIA_OUTDOORS':
        return new TileLayer({
          source: new StadiaMaps({
            layer: 'outdoors',
            retina: true,
          }),
        })
      case 'XYZ':
        return new TileLayer({
          source: new XYZ({
            url: 'https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}',
            crossOrigin: 'anonymous',
          }),
        })
      case 'OSM_HOT':
        return new TileLayer({
          source: new OSM({
            url: 'https://{a-c}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
          }),
        })
      case 'OSM_DE':
        return new TileLayer({
          source: new OSM({
            url: 'https://{a-c}.tile.openstreetmap.de/{z}/{x}/{y}.png',
          }),
        })
      case 'ESRI_IMAGERY':
        return new TileLayer({
          source: new XYZ({
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            attributions: 'Tiles © Esri',
          }),
        })
      case 'ESRI_WORLD_IMAGERY':
        return new TileLayer({
          source: new XYZ({
            url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            attributions: 'Tiles © Esri — Source: Esri, Maxar, Earthstar Geographics, etc.',
            crossOrigin: 'anonymous',
          }),
        })
      case 'NASA_GIBS':
        return new TileLayer({
          source: new XYZ({
            url: 'https://gibs.earthdata.nasa.gov/wmts/epsg3857/best/BlueMarble_NextGeneration/default/GoogleMapsCompatible_Level8/{z}/{y}/{x}.jpg',
            attributions: 'NASA Global Imagery Browse Services',
            crossOrigin: 'anonymous',
          }),
        })
      case 'GOOGLE_SATELLITE':
        return new TileLayer({
          source: new XYZ({
            url: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
            attributions: '© Google Satellite',
            crossOrigin: 'anonymous',
          }),
        })
      case 'CARTO_DARK':
        return new TileLayer({
          source: new XYZ({
            url: 'https://{a-d}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
          }),
        })
      case 'CYCLOSM':
        return new TileLayer({
          source: new XYZ({
            url: 'https://{a-c}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
          }),
        })
      case 'OPENTOPOMAP':
        return new TileLayer({
          source: new XYZ({
            url: 'https://{a-c}.tile.opentopomap.org/{z}/{x}/{y}.png',
          }),
        })
      case 'OSM':
      default:
        return new TileLayer({
          source: new OSM(),
        })
    }
  }, [baseLayerSourceName])

  return createLayer
}

export default useBaseLayer
